/* tslint:disable */
/* eslint-disable */
/**
 * JET Charge Illuminate Web API
 * JET Charge Illuminate Web API
 *
 * The version of the OpenAPI document: 1.0.0
 * Contact: rd@jetcharge.com.au
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from "../runtime";
/**
 *
 * @export
 * @interface ContactDto
 */
export interface ContactDto {
    /**
     *
     * @type {number}
     * @memberof ContactDto
     */
    contactId?: number;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    name?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    phoneNo?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    email?: string;
    /**
     *
     * @type {string}
     * @memberof ContactDto
     */
    role?: string;
}

/**
 * Check if a given object implements the ContactDto interface.
 */
export function instanceOfContactDto(value: object): value is ContactDto {
    return true;
}

export function ContactDtoFromJSON(json: any): ContactDto {
    return ContactDtoFromJSONTyped(json, false);
}

export function ContactDtoFromJSONTyped(
    json: any,
    ignoreDiscriminator: boolean,
): ContactDto {
    if (json == null) {
        return json;
    }
    return {
        contactId: json["contactId"] == null ? undefined : json["contactId"],
        name: json["name"] == null ? undefined : json["name"],
        phoneNo: json["phoneNo"] == null ? undefined : json["phoneNo"],
        email: json["email"] == null ? undefined : json["email"],
        role: json["role"] == null ? undefined : json["role"],
    };
}

export function ContactDtoToJSON(value?: ContactDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        contactId: value["contactId"],
        name: value["name"],
        phoneNo: value["phoneNo"],
        email: value["email"],
        role: value["role"],
    };
}
